import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, first } from 'rxjs';

import { ApiResponse } from 'src/app/shared/interfaces/api-response.interface';
import { TamanhoRequestModel, TamanhoResponseModel } from 'src/app/shared/models/tamanho.model';
import { AuthenticationService } from './authentication.service';
import { ProdutosComTamanhoRequest, Tamanho } from 'src/app/shared/models/produto.model';

@Injectable({
    providedIn: 'root'
})
export class TamanhoService {
    constructor(
        private httpClient: HttpClient,
        private authService: AuthenticationService
    ) { }

    private get base() {
        return `${this.authService.baseUrl}/ProdutosComTamanho`;
    }

    create(model: TamanhoRequestModel): Observable<ApiResponse<TamanhoRequestModel>> {
        return this.httpClient.post<ApiResponse<TamanhoRequestModel>>(this.base + '/create', model).pipe(
            first()
        );
    }

    delete(id: number): Observable<ApiResponse<any>> {
        return this.httpClient.delete<ApiResponse<any>>(this.base + '/' + id).pipe(
            first()
        );
    }

    getTamanhosLasanha() {
        return this.httpClient.get<ApiResponse<TamanhoResponseModel[]>>(`${this.base}/tamanhosLasanha`).pipe(
            first()
        );
    }

    getTamanhosPizza() {
        return this.httpClient.get<ApiResponse<TamanhoResponseModel[]>>(`${this.base}/tamanhosPizza`).pipe(
            first()
        );
    }

    alterarProdutoTamanho(model: ProdutosComTamanhoRequest) {
        return this.httpClient.put<ApiResponse<ProdutosComTamanhoRequest>>(`${this.base}`, model).pipe(
            first()
        );
    }
}
